import { render, staticRenderFns } from "./Emergencies.vue?vue&type=template&id=8c064090&scoped=true"
import script from "./Emergencies.vue?vue&type=script&lang=js"
export * from "./Emergencies.vue?vue&type=script&lang=js"
import style0 from "./Emergencies.vue?vue&type=style&index=0&id=8c064090&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c064090",
  null
  
)

export default component.exports